import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SplashScreen from "../Splash";

// PrivateRoute component as a wrapper for protected routes
const PrivateRoute = ({ sessionLoader, loginLoader, gameLoader, children }) => {
  const { user, loading } = useSelector(({ Auth }) => Auth);
  // console.info("private route sessionLoader =====>", sessionLoader);
  // console.info("private route loginLoader =====>", loginLoader);
  // console.info("private route gameLoader =====>", gameLoader);
  // console.info("private route auth loading =====>", loading); 
  // console.info("private route user Status =====>", user?.status); 
  
  if (user?._id) {
    if (!user.status === "pending") {
      return <Navigate to="/verify-otp" />;
    }
    return children;
  }
  else if (sessionLoader || loginLoader || gameLoader || loading) {
    return <SplashScreen />;
  }
  return <Navigate to="/login" />;
};

export default PrivateRoute;
